import styled from 'styled-components'

export const TickMark = styled.div`
    display: inline-block;
    width: 22px;
    height: 22px;
    -ms-transform: rotate(45deg); /* IE 9 */
    -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
    transform: rotate(45deg);
    margin: 5px 10px 0px 0px;
`

export const TickMarkStem = styled.div`
    position: absolute;
    width: 2px;
    height: 18px;
    background-color: #e87d7c;
    left: 20px;
    top: 4px;
}
`

export const TickMarkKick = styled.div`
    position: absolute;
    width: 7px;
    height: 2px;
    background-color: #e87d7c;
    left: 14px;
    top: 20px;
`
